export class BackToTopButton {
  constructor() {
    window.addEventListener("DOMContentLoaded", () => this.initialize());
  }

  private initialize(): void {
    const button = document.getElementById("button-back-top-top");

    if (!button) return;

    this.addClickListener(button);
    this.addScrollListener(button);
    this.observeStickyCta();
  }

  private addClickListener(button: HTMLElement): void {
    button.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      button.blur();
    });
  }

  private addScrollListener(button: HTMLElement): void {
    let ticking = false;

    const handleScroll = () => {
      const parent = button.parentElement;
      if (!parent) return;

      const shouldShow = window.scrollY > window.innerHeight * 0.5;

      if (shouldShow) {
        parent.setAttribute("data-active", "");
      } else {
        parent.removeAttribute("data-active");
      }

      ticking = false;
    };

    // Throttling scrollListener via requestAnimationFrame
    window.addEventListener("scroll", () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(handleScroll);
      }
    });
  }

  // Checking if .pda-sticky-cta-box exists -> product page
  // If it does, observe body for class changes of class "pda-sticky", which shows/hides the sticky cta bar
  // Add/remove bottom offsets for the sticky buttons accordingly
  private observeStickyCta(): void {
    const pdaSticky = document.querySelector<HTMLElement>(
      ".pda-sticky-cta-box",
    );
    const stickyButtons = document.getElementById("sticky-buttons");

    if (!pdaSticky || !stickyButtons) return;

    let lastClassState = document.body.classList.contains("pda-sticky");

    const observer = new MutationObserver((mutations: MutationRecord[]) => {
      for (const mutation of mutations) {
        // Have observer only observe class changes
        if (
          mutation.type !== "attributes" ||
          mutation.attributeName !== "class"
        ) {
          continue;
        }

        const currentClassState = (
          mutation.target as HTMLElement
        ).classList.contains("pda-sticky");

        // If class change is observed
        if (lastClassState !== currentClassState) {
          lastClassState = currentClassState;

          // If .pda-sticky is set -> set sticky buttons bottom offset, otherwise remove it
          if (currentClassState) {
            stickyButtons.setAttribute(
              "style",
              `bottom: ${pdaSticky.offsetHeight}px !important`,
            );
          } else {
            stickyButtons.removeAttribute("style");
          }
        }
      }
    });

    observer.observe(document.body, { attributes: true });
  }
}

// Initialize on load
new BackToTopButton();
